import React from 'react'
import pt from 'prop-types'
import noop from 'lodash/noop'
import memoWithName from '@/hocs/memoWithName'

const SortAscendingIcon = ({ color, onClick }) => {

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 16.9985H22L18 20.9985L14 16.9985H17V2.99854H19V16.9985ZM2 16.9985H12V18.9985H2V16.9985ZM6 4.99854V6.99854H2V4.99854H6ZM2 10.9985H9V12.9985H2V10.9985Z" fill="#838D99"/>
    </svg>
  )
}

SortAscendingIcon.propTypes = {
  color: pt.string,
  onClick: pt.func,
}

SortAscendingIcon.defaultProps = {
  color: null,
  onClick: noop,
}

export default memoWithName(SortAscendingIcon)
